import {
  RETURN_SUBMISSION_RECEIVED,
  CLEAR_RETURN_SUBMISSION,
  RECEIVE_LABEL_URL,
  RECEIVE_PRINTERLESS_URL,
  RECEIVE_MULTI_LABEL,
  RECEIVE_ATTESTATION_VALUE,
} from '../../actions/returnSubmission';

export const initialState = {
  errors: {},
  returnProcessInfo: {},
  labelUrl: '',
  printerlessUrl: '',
  attestation: {},
};

export default (
  state = initialState,
  {
    type,
    data: { errors, returnProcessInfo, labelUrl, printerlessUrl, multiLabel, field, value } = {},
  } = {},
) => {
  switch (type) {
    case RETURN_SUBMISSION_RECEIVED:
      return { ...state, errors, returnProcessInfo };

    case CLEAR_RETURN_SUBMISSION:
      return initialState;

    case RECEIVE_LABEL_URL:
      return {
        ...state,
        labelUrl,
      };

    case RECEIVE_PRINTERLESS_URL:
      return {
        ...state,
        printerlessUrl,
      };

    case RECEIVE_MULTI_LABEL:
      return {
        ...state,
        multiLabel,
      };

    case RECEIVE_ATTESTATION_VALUE:
      return {
        ...state,
        attestation: {
          ...state.attestation,
          [field]: value,
        },
      };

    default:
      return state;
  }
};
